exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product.collection-product[data-v-295ea81d]{padding:0}\n", ""]);

// exports
